import React, { useState } from "react";
import ReactJson from "react18-json-view";
// import "react18-json-view/src/style.css";
import { ClipboardCopy } from "lucide-react";

type JSONDisplayProps = {
  data: any;
};

const JSONDisplay: React.FC<JSONDisplayProps> = ({ data }) => {
  const [copyStatus, setCopyStatus] = useState < string > "Copy";

  const handleCopy = () => {
    const jsonString = JSON.stringify(data, null, 2);
    navigator.clipboard
      .writeText(jsonString)
      .then(() => {
        setCopyStatus("Copied!");
        setTimeout(() => setCopyStatus("Copy"), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        setCopyStatus("Failed!");
        setTimeout(() => setCopyStatus("Copy"), 2000);
      });
  };

  return (
    <div className="bg-slate-800 text-slate-300 rounded-xl shadow-lg flex flex-col h-full flex-grow">
      <div className="flex-shrink-0 flex items-center justify-between p-3 bg-slate-900/70 border-b border-slate-700 rounded-t-xl">
        <h3 className="font-mono text-sm font-semibold tracking-wider">
          RAW JSON OUTPUT
        </h3>
        <button
          onClick={handleCopy}
          className="flex items-center space-x-2 px-3 py-1 bg-slate-700 hover:bg-slate-600 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <ClipboardCopy size={16} />
          <span>{copyStatus}</span>
        </button>
      </div>

      <div className="flex-grow overflow-y-auto p-4">
        <ReactJson
          src={data}
          theme="monokai"
          iconStyle="square"
          collapsed={false}
          displayDataTypes={false}
          displayObjectSize={false}
          enableClipboard={false}
          style={{
            width: "100%",
            backgroundColor: "transparent",
            fontFamily: "inherit",
          }}
        />
      </div>
    </div>
  );
};

export default JSONDisplay;
